<div class="card m-4 p-4">
  <div class="row">
    <h2 class="col-sm-8">Change Your Booking</h2>
    <div class="float-right col-sm-4">
      <button (click)="changeDateTImecreenCloseClick()" class="ba-btn ba-btn-sq-sm float-right" role="button"><i class="fa fa-times"></i></button>
    </div>
  </div>
  <form [formGroup]="changeBookingForm">
    <div formArrayName="boundOffersArray">
      <div *ngFor="let boundAirlineOffer of changeYourBookingScreendeatils.boundAirlineOfferList; let i = index; trackBy: trackFn">
        <div class="odrow" [formGroupName]="i">
          <div class="row bgodrw mb-3">
            <div class="col-md-1">
              <input type="checkbox" id="chx-OD1" name="chx-OD1" class="form-input" (click)="makeOfferSelected(i)" />
            </div>
            <div class="col-md-5">
              <h5>
                {{ boundAirlineOffer.flightsDetails[0].departureAirportCode }} -
                {{ boundAirlineOffer.flightsDetails[boundAirlineOffer.flightsDetails.length - 1].arrivalAirportCode }}
              </h5>
            </div>

            <div class="col-md-3">
              <input class="form-input" type="date" formControlName="depatureDate" />
            </div>

            <div class="col-md-3">
              <select id="cbn-OD1" name="cbn-OD1" class="form-input ms-1" formControlName="cabinPreference">
                <option *ngFor="let cabin of cabins" [value]="cabin.value">{{ cabin.cabin }}</option>
              </select>
            </div>
          </div>
          <div class="row" *ngFor="let flightDetails of boundAirlineOffer.flightsDetails">
            <div class="col-md-1"></div>
            <div class="col-md-2">{{ flightDetails.airlineId }}{{ flightDetails.flightNumber }} {{ flightDetails.flightType }}</div>

            <div class="col-md-3">
              <b> {{ flightDetails.flightTime }} </b>

              {{ flightDetails.flightDate }}
            </div>
            <div class="col-md-2">{{ flightDetails.departureAirportCode }} - {{ flightDetails.arrivalAirportCode }}</div>
            <div class="col-md-2">{{ flightDetails.flightDuration }}</div>
            <div class="col-md-2">{{ flightDetails.cabinPrefrences }}</div>
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <button type="button" [disabled]="disabledGetOffer" class="ba-btn ba-btn-vthin float-right" role="button" (click)="GetReshopOffers()"><i class="fa fa-binoculars"></i> Get Offers</button>
      </div>
    </div>
  </form>

  <ng-template class="mt-5" [ngIf]="changeYourBookingScreendeatils.reshopAirlineOffers.length > 0">
    <h2>Reshop Offers</h2>
    <div class="reshopOffers" *ngFor="let airlineOffer of changeYourBookingScreendeatils.reshopAirlineOffers; let airLineOffersIndex = index">
      <div class="row p-2">
        <div class="col-sm-8 offer">
          <div class="posRelative" *ngFor="let boundDetails of airlineOffer.boundAirlineOffer; let boundIndex = index; let boundFirstIndex = first; let boundLastIndex = last">
            <div class="row p-2">
              <div
                *ngFor="let flightDetail of boundDetails?.flightDetails; let flightIndex = index; let flightLastIndex = last; let flightFirstIndex = first"
                [class.mb-2]="boundFirstIndex"
                [class.mt-2]="boundLastIndex"
                class="col-sm-12"
              >
                <div class="row p-1">
                  <div class="col-sm-1">
                    <img *ngIf="getFlightLogoUrl(flightDetail.airlineName) !== ''" class="pt-10" [src]="getFlightLogoUrl(flightDetail.airlineName)" />
                  </div>
                  <div class="col-sm-2 pr-0">
                    <span class="pdtitle reshopBlue">{{ flightDetail.marketingName }}</span
                    ><br />
                    <span class="pdtitle reshopBlue">{{ flightDetail.economyType }} </span><br />
                  </div>
                  <div class="col-sm-3">
                    <div class="fltDate">{{ flightDetail.departureDateWithYear }}</div>
                    <div class="fltgrp">
                      <div class="flTime">{{ flightDetail.departureTimeIn24H }}</div>
                      <div class="flAirpt">
                        {{ flightDetail.departureAirportCode }}
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div style="text-align: center">
                      <span style="font-size: 12px">{{ flightDetail.duriation }} </span>
                      <ul class="Leg-line"></ul>
                      <span style="font-size: 12px; color: #074e11">{{ flightDetail.airlineId }}{{ flightDetail.airlineNumber }} | {{ flightDetail.ClassOfServiceCode }} </span>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="flTime">{{ flightDetail.arrivalTimeIn24H }}</div>
                    <div class="flAirpt">
                      {{ flightDetail.arrivalAirportCode }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-2 flTime" style="margin-top: 1.2rem">
          {{ roundOffAirlinePriceDetails(airlineOffer.priceDetail.price) }}<sup class="sm-cur mt-4">{{ airlineOffer.priceDetail.currency }}</sup>
        </div>
        <div class="col-sm-2 flTime" style="margin-top: 1.2rem">
          <button role="button" class="ba-btn sml" (click)="getSelectedOfferPrice(airlineOffer.offerIndex)">Select Offer</button>
        </div>
      </div>
    </div>
  </ng-template>
</div>
